import styled, { css } from 'styled-components';
import { getSpacingToken, getTextTokenPreset, SpacingToken } from '@optimus-web/common';
import { getTypographyColor, TypographyVariant } from '../typography';

interface SimpleListProps {
    children: React.ReactNode;
    /** length or "auto", CSS default is "auto", [CSS docs](https://developer.mozilla.org/en-US/docs/Web/CSS/column-width) */
    columnWidth?: string;
    ordered?: boolean;
    plain?: boolean;
    indent?: SpacingToken;
    listStyle?: 'none' | 'initial';
    variant?: TypographyVariant;
}

const BaseList = styled.ul<SimpleListProps>`
    margin: 0;
    color: ${({ variant }) => getTypographyColor({ variant })};
    ${(props) => (props.plain ? '' : getTextTokenPreset('bodyLarge'))}
    ${(props) =>
        props.indent !== undefined &&
        css`
            padding-left: ${getSpacingToken(props.indent)}px;
        `}
    ${(props) =>
        props.listStyle &&
        css`
            list-style: ${props.listStyle};
        `}
    ${(props) =>
        props.columnWidth != null &&
        css`
            column-width: ${props.columnWidth};
        `}
`;

export const SimpleList = ({ ordered, children, ...other }: SimpleListProps) => (
    <BaseList as={ordered ? 'ol' : 'ul'} {...other}>
        {children}
    </BaseList>
);
